export default __webpack_public_path__ + "static/media/hotelBook3.8947a146.jpg";